export const STALE_TIME = 2 * 60 * 1000; // minutes to milliseconds
